export default {"src":"/_next/static/media/my-profile.12198a92.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};